import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField/TextField'
import React, { useEffect, useRef } from 'react'
import { COLORS } from '../../../styles/colors'

interface ICustomTextFieldProps {
	label: string
	value: string
	error?: boolean
	helperText?: string
	width: string
	onChange?: (e: any) => void
	onClick?: (e: any) => void
	onBlur?: (e: any) => void
	type?: string
	withLabel?: boolean
}

const CustomRationInput = (props: ICustomTextFieldProps) => {
	const inputElem = useRef(null)

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const inputValue = e.target.value

		if (!/^\d*(\.\d{0,2})?$/.test(inputValue)) {
			e.preventDefault()
			return
		}

		if (props.onChange) {
			props.onChange(e)
		}
	}

	const enterPressHandler = e => {
		if (e.key === 'Enter') {
			e.target.blur()
		}
		if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
			e.preventDefault()
		}
	}

	const exceptSymbols = ['e', 'E', '+', '-']

	useEffect(() => {
		const handleWheel = e => {
			e.target.blur()
		}
		if (inputElem.current) {
			inputElem.current.addEventListener('wheel', handleWheel)
		}

		return () => {
			if (inputElem.current) {
				inputElem.current.removeEventListener('wheel', handleWheel)
			}
		}
	}, [])

	const hasValue = (() => {
		if (props.value === null || props.value === undefined || props.value === '')
			return false

		if (/^\d+\.?$/.test(props.value)) return true

		return true
	})()

	const valueWidth = `${String(props.value ?? '').length + 0.5}ch`

	return (
		<TextField
			variant='outlined'
			placeholder={hasValue ? '' : props.label}
			value={props.value}
			type={props.type}
			error={props.error}
			onKeyPress={enterPressHandler}
			onKeyDown={e => {
				exceptSymbols.includes(e.key) && e.preventDefault()
				if (
					!/[\d.]/.test(e.key) &&
					!['Backspace', 'ArrowRight', 'ArrowLeft', ','].includes(e.key)
				) {
					e.preventDefault()
				}
			}}
			ref={inputElem}
			autoComplete='off'
			helperText={props.helperText}
			sx={{
				width: '100px',
				flexShrink: 0,
				'& .MuiOutlinedInput-root': {
					width: '100px',
					height: '40px',
					borderRadius: '8px',
					padding: '0 8px',
					boxSizing: 'border-box',
					display: 'flex',
					justifyContent: 'center',
					'& fieldset': {
						border: `1px solid ${COLORS.inputBorder}`,
					},
					'&:hover fieldset': {
						border: `1px solid ${COLORS.hoverInputBorder}`,
					},
					'&.Mui-focused fieldset': {
						border: `1px solid ${COLORS.main}`,
					},
				},
				'& .MuiOutlinedInput-notchedOutline legend': { display: 'none' },
				'& .MuiOutlinedInput-notchedOutline': { top: 0 },
				'& .MuiInputBase-input': {
					width: hasValue ? valueWidth : '100%',
					minWidth: 0,
					height: '40px',
					padding: 0,
					boxSizing: 'border-box',
					fontSize: '14px',
					color: COLORS.black,
					textAlign: hasValue ? 'right' : 'center',
					MozAppearance: 'textfield',
					'&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
						WebkitAppearance: 'none',
						margin: 0,
					},
					'&::placeholder': {
						color: COLORS.secondaryFont,
						opacity: 1,
					},
				},
			}}
			onChange={handleChange}
			onClick={props.onClick}
			onBlur={props.onBlur}
			InputProps={{
				endAdornment: hasValue ? (
					<InputAdornment
						disableTypography={true}
						position='end'
						sx={{
							fontSize: '14px',
							color: COLORS.secondaryFont,
							marginLeft: '4px',
							height: 'auto',
						}}
					>
						кг/гол
					</InputAdornment>
				) : null,
			}}
		/>
	)
}

export default CustomRationInput
